module.exports = __webpack_public_path__ + "img/grass-transition.af6ea9a7.png";